<template>
  <!-- <div class="index-menu"> -->

  <div id="navigation" class="nav" style="text-align: left; padding-left: 200px;">
    
          <span class="logo">{{title}}</span>
    <!-- <br> -->
    <!-- <el-menu
      :default-active="$route.path"
      router
      mode="horizontal"
      text-color="#222"
      active-text-color="#133b95"

    > -->
      <!-- <el-menu-item style="position: relative;margin-left:10%"> -->
          <!-- <a href="/index"> -->
        <!-- <img class="img-logo" src="../../assets/img/bg/logo1.png" v-if="websiteType==0"/>
        <img class="img-logo" src="../../assets/img/bg/logo1.png" v-if="websiteType==1"/>
        <img class="img-logo" src="../../assets/img/bg/logo1.png" v-if="websiteType==2"/>
        <img class="img-logo" src="../../assets/img/bg/logo1.png" v-if="websiteType==3"/> -->
          <!-- </a> -->
      <!-- </el-menu-item> -->
      <!-- <el-menu-item v-for="(item,i) in navList" :key="i" :index="item.name">
          {{item.navItem}}
      </el-menu-item>-->
      <!-- <el-menu-item :index="'/index'" style="left :42%;" class="nav_text">首页</el-menu-item>
      <el-menu-item :index="'/about'" style="left :47%;" class="nav_text">关于腾盛</el-menu-item> -->
      <!-- <el-menu-item :index="'/bussiness'" style="left:42%" class="nav_text">业务介绍</el-menu-item> -->
      <!-- <el-menu-item :index="'/join'" style="left:52%" class="nav_text">加入我们</el-menu-item> -->
    <!-- </el-menu> -->
  </div>
  <!-- </div>-->
</template>

<script>
export default {
  name: "NavMenu",
  data () {
      return {
          title:'',
          imgSrc:'',
           websiteType:0, 
          //  1  ilegong  2 wl 3 daozheng  0 ts
      }
  },
  created(){
      console.log(window.location.href);
      if(window.location.href.indexOf('ilegong.cn')>=0){
              this.websiteType =1;
      }else if(window.location.href.indexOf('hnwltech.com')>=0){
        this.websiteType =2;
      }else if(window.location.href.indexOf('hndaozheng.com')>=0){
        this.websiteType =3;
      }else{
        this.websiteType =0;
      }

       
      if(this.websiteType ==1){
          this.title = '乐工';

      }else if(this.websiteType ==2){
          this.title = '浯浪';
        
      }else if(this.websiteType ==3){
          this.title = '道政';
        
      }else if(this.websiteType ==0){
          this.title = '腾盛';
        
      }
  }
};
</script>
<style >
.logo{
  font-size: 40px;
  font-weight: bold;
    color:#133B95;
}
.img-logo{
   margin-top: -15px;

}
.nav_text{
  font-size: 14px;color: #666666
}

</style>



// WEBPACK FOOTER //
// src/components/common/NavMenu.vue